import React from 'react'
import PlanWrapper from '../../Common/PlanWrapper'

const MealPlansWrapper = () => <PlanWrapper planType='meal' planLabel='Meal Plans' isMonitoring={true} />

export default MealPlansWrapper
